import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/es/tooltip';
import React, { CSSProperties } from 'react';

const defaultInnerStyle: CSSProperties = {
  padding: '16px',
  fontSize: '12px',
  pointerEvents: 'all',
};

const defaultOverlayStyle: CSSProperties = {
  zIndex: '10000',
};

export const CustomTooltip = ({
  className,
  children,
  overlayStyle = defaultOverlayStyle,
  ...restProps
}: TooltipProps): JSX.Element => (
  <Tooltip
    overlayClassName={className}
    {...restProps}
    overlayInnerStyle={defaultInnerStyle}
    overlayStyle={overlayStyle}
  >
    <div>{children}</div>
  </Tooltip>
);

export default CustomTooltip;
